"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonLabel = exports.passwordLabel = exports.emailLabel = exports.nameLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var nameLabel = /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "EmailPasswordSignUpForm.name",
  defaultMessage: "Name"
});

exports.nameLabel = nameLabel;

var emailLabel = /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "EmailPasswordSignUpForm.email",
  defaultMessage: "Email Address"
});

exports.emailLabel = emailLabel;

var passwordLabel = /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "EmailPasswordSignUpForm.password",
  defaultMessage: "Password"
});

exports.passwordLabel = passwordLabel;

var buttonLabel = /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
  id: "EmailPasswordSignUpForm.signup",
  defaultMessage: "Create account"
});

exports.buttonLabel = buttonLabel;